import { ICriteria } from "./criteria";

export enum CriteriaGroupMethodEnum {
    AND = "and",
    OR = "or",
    NOT = "not",
}

export interface ICriteriaGroup {
    id?: number;
    questionnaire_id: number;
    title: string;
    method: CriteriaGroupMethodEnum;
    criterias: ICriteria[];
}